import { useNavigate } from 'react-router-dom'

import { Box } from '@factorialco/deprecated-design-system'
import { ResourceHeader } from '@factorialco/f0-react/dist/experimental'
import { Settings } from '@factorialco/f0-react/icons/app'
import { ItemIntegrationFragment } from 'generated/resources/graphql'

import { useLazyRef } from 'modules/core/hooks/useLazyRef'
import { useNavigation } from 'modules/core/hooks/useNavigation'
import i18n from 'modules/core/lib/i18n'

import { InstallWorkflow } from 'modules/marketplace/components/Item/InstallWorkflow'
import { useShowIntegrationSettings } from 'modules/marketplace/hooks/integrations/useShowIntegrationSettings'
import {
  CompanyInstallations,
  CompanyInstallationsProvider,
} from 'modules/marketplace/store/collections/companyInstallations'

import './index.styles.css'
interface ItemHeaderProps {
  integration?: ItemIntegrationFragment
}
export const ItemHeader = ({ integration }: ItemHeaderProps) => {
  const navigate = useNavigate()
  const { navigation } = useNavigation()
  const companyInstallationCollection = useLazyRef(() => new CompanyInstallations()).current
  const showSettingsButton = useShowIntegrationSettings(integration)

  if (!integration) return null

  const actions = () => {
    return [
      {
        label: i18n.t('marketplace.integrations.settings'),
        icon: Settings,
        isVisible: showSettingsButton,
        onClick: () => {
          navigate(
            navigation.discover.marketplace.item.settings.fullPath({
              id: integration.datoId,
            })
          )
        },
      },
    ]
  }

  return (
    <CompanyInstallationsProvider collection={companyInstallationCollection}>
      <Box paddingRight="s24" className={'ItemHeader_headerWrapper'}>
        <ResourceHeader
          avatar={{
            type: 'company',
            name: integration.name || '',
            src: integration.logo?.url || '',
          }}
          title={integration.name || ''}
          description={integration.shortDescription || ''}
          secondaryActions={actions()}
        />
        <InstallWorkflow integration={integration} />
      </Box>
    </CompanyInstallationsProvider>
  )
}
